import { Card, CardContent } from "@/components/ui/card";

const OvertimeRequests = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Overtime Requests</h1>
          <p className="text-muted-foreground">
            Manage overtime requests for your team
          </p>
        </div>
      </div>
      
      <Card>
        <CardContent>
          <div className="text-center py-6">
            <p className="text-muted-foreground">No overtime requests found</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OvertimeRequests;
